import { Component, EventEmitter, Input, Output } from '@angular/core';
import { LayoutService, ScreenSize } from 'libs/portal/src/layout/layout.service';
import { CardTableAction } from '../../models';

@Component({
  selector: 'app-card-table-actions',
  template: ` @if (!makeCheckbox) {
    <div class="wrapper">
      @if (!makeToggle && actions != null && actions.length > 0) {
      <div class="actions-wrapper" [ngClass]="{ 'actions-wrapper-card': layoutService.screenSize <= breakpoint }">
        @for (action of actions; track action) {
        <app-card-table-action
          [iconName]="action.iconName"
          [iconSrc]="action.iconSrc"
          [showIcon]="action.showIcon"
          [color]="action.color"
          [title]="action.title"
          (clickedEvent)="clicked($event)"
          [breakpoint]="breakpoint"
          [display]="action.display"
          class="quickAction"
        >
        </app-card-table-action>
        }
      </div>
      } @if (!makeToggle && listActions != null) {
      <div>
        <button mat-icon-button [matMenuTriggerFor]="menu">
          <mat-icon>more_vert</mat-icon>
        </button>
        <mat-menu #menu="matMenu">
          <div style="font-size: 18px !important">
            @for (action of listActions; track action) {
            <app-card-table-action
              [iconName]="action.iconName"
              [iconSrc]="action.iconSrc"
              [showIcon]="action.showIcon"
              [color]="action.color"
              [title]="action.title"
              (clickedEvent)="clicked($event)"
              [breakpoint]="breakpoint"
              [display]="action.display"
            >
            </app-card-table-action>
            }
          </div>
        </mat-menu>
      </div>
      } @if (makeToggle) {
      <div>
        <app-card-table-action
          [title]="toggleTitle"
          (toggledEvent)="toggled($event)"
          [breakpoint]="breakpoint"
          [makeToggle]="makeToggle"
          [subCustomersToggled]="row.subCustomersToggled"
        >
        </app-card-table-action>
      </div>
      }
    </div>
    } @if (makeCheckbox) {
    <div class="actions-wrapper checkbox">
      <app-card-table-action (checkedEvent)="checked($event)" [breakpoint]="breakpoint" [makeCheckbox]="makeCheckbox" [valueChecked]="row.selected"> </app-card-table-action>
    </div>
    }`,
  styles: [
    `
      .wrapper {
        display: inline-flex;
        align-items: center;
        cursor: pointer;
      }

      .actions-wrapper {
        display: flex;
        flex-wrap: nowrap;
        justify-content: center;
        align-items: center;
      }

      .quickAction {
        display: inline-flex;
      }

      .quickAction:last-child {
        margin-right: 10px;
      }

      .quickAction:not(:last-child):after {
        content: '|';
        margin-left: 6px;
        margin-right: 8px;
        font-size: 20px;
        color: var(--ion-color-medium);
        display: flex;
        align-items: center;
      }

      .actions-wrapper-card {
        position: absolute;
        right: 0;
        bottom: 5;
        bottom: 5px;
      }

      .actions-wrapper-card .quickAction:not(:last-child):after {
        content: '|';
        margin-left: 6px;
        margin-right: 8px;
        font-size: 20px;
        color: var(--ion-color-medium);
      }

      .checkbox {
        margin: 4px 3px 0 3px;
      }
    `,
  ],
})
export class CardTableActionsComponent {
  @Input() row: any;
  @Input() actions: CardTableAction[];
  @Input() breakpoint: ScreenSize;
  @Input() makeToggle: boolean;
  @Input() makeCheckbox: boolean;
  @Input() toggleTitle: string;
  @Input() valueChecked: boolean;
  @Input() listActions: any;

  @Output() actionEvent = new EventEmitter<any>();

  constructor(public layoutService: LayoutService) {}

  clicked($event: any) {
    this.actionEvent.emit({ title: $event, row: this.row });
  }

  toggled($event: any) {
    this.actionEvent.emit({ toggled: $event, row: this.row });
    // console.log({ toggled: $event, row: this.row })
  }

  checked($event: any) {
    this.actionEvent.emit({ checked: $event, row: this.row });
    // console.log({ title: $event, row: this.row })
  }
}
